import React from 'react';
import ReactDOM from 'react-dom';
import './style.scss';


function FixedButtons({ children }) {

    const fixedButtonsRoot = document.getElementById('fixed-buttons-root');

    return ReactDOM.createPortal(
        <div className="fixed-buttons">
            {children}
        </div>,
        fixedButtonsRoot
    )
}

export default FixedButtons;
